module.exports = __webpack_public_path__ + "img/nginx.41613c86.png";